import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DollarSign, ArrowLeft, FileText, Calendar } from 'lucide-react';
import api from '../services/api';

const MySalary = () => {
    const navigate = useNavigate();
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get('/payroll/my-history')
            .then(res => setHistory(res.data))
            .catch(err => console.error(err))
            .finally(() => setLoading(false));
    }, []);

    const viewSlip = (month, year) => {
        api.get('/payroll/slip', { params: { userId: JSON.parse(localStorage.getItem('user')).id, month, year }, responseType: 'text' })
            .then(res => {
                const win = window.open('', '_blank');
                win.document.write(res.data);
                win.document.close();
            })
            .catch(e => alert(e.response?.data?.error || 'Failed to get slip'));
    };

    return (
        <div className="container section">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
                <button
                    onClick={() => navigate('/dashboard')}
                    style={{ display: 'flex', alignItems: 'center', color: '#4b5563', background: 'none', border: 'none', cursor: 'pointer' }}
                >
                    <ArrowLeft size={20} style={{ marginRight: '0.5rem' }} />
                    Back to Home
                </button>
            </div>

            <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '1.5rem', display: 'flex', alignItems: 'center' }}>
                <DollarSign style={{ marginRight: '0.75rem', color: '#2563eb' }} /> My Salary History
            </h1>

            <div className="glass-card" style={{ padding: 0, overflow: 'hidden' }}>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                                <th style={{ padding: '1rem', fontWeight: '600' }}>Month</th>
                                <th style={{ padding: '1rem', fontWeight: '600' }}>Payable Days</th>
                                <th style={{ padding: '1rem', fontWeight: '600' }}>Monthly CTC</th>
                                <th style={{ padding: '1rem', fontWeight: '600' }}>Unpaid Leaves</th>
                                <th style={{ padding: '1rem', fontWeight: '600' }}>Net Pay</th>
                                <th style={{ padding: '1rem', fontWeight: '600', textAlign: 'right' }}>Slip</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="6" style={{ padding: '2rem', textAlign: 'center' }}>Loading...</td></tr>
                            ) : history.length === 0 ? (
                                <tr><td colSpan="6" style={{ padding: '2rem', textAlign: 'center' }}>No salary history found.</td></tr>
                            ) : (
                                history.map((r, i) => (
                                    <tr key={i} style={{ borderBottom: '1px solid #f3f4f6' }}>
                                        <td style={{ padding: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                            <Calendar size={16} />
                                            {new Date(0, r.month - 1).toLocaleString('default', { month: 'long' })} {r.year}
                                        </td>
                                        <td style={{ padding: '1rem' }}>{r.payableDays}</td>
                                        <td style={{ padding: '1rem' }}>{new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(r.grossSalary)}</td>
                                        <td style={{ padding: '1rem', color: r.unpaidDaysCount > 0 ? 'red' : 'inherit' }}>{r.unpaidDaysCount}</td>
                                        <td style={{ padding: '1rem', fontWeight: 'bold' }}>{new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(r.netPay)}</td>
                                        <td style={{ padding: '1rem', textAlign: 'right' }}>
                                            <button
                                                onClick={() => viewSlip(r.month, r.year)}
                                                style={{ border: 'none', background: 'none', color: '#2563eb', cursor: 'pointer', fontWeight: '500' }}
                                            >
                                                View Slip
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default MySalary;
